import { downgradeInjectable } from '@angular/upgrade/static';
import { module } from 'angular';

import { AgentUserConfService, PositionService, UserStmService } from '@contact/upgrade';

import { AgentConfigDeprecatedService, default as agentConfigDeprecatedServiceName } from './agent-config-deprecated.service';
import { AgentStatusDeprecatedService, default as agentStatusDeprecatedServiceName } from './agent-status-deprecated.service';
import { default as positionDeprecatedServiceName, PositionDeprecatedService } from './position-deprecated.service';

export default module('contact.agent.core.agent', [])
  // instantiate services module
  .run([agentConfigDeprecatedServiceName, () => {}])
  // configuration
  .service(agentConfigDeprecatedServiceName, AgentConfigDeprecatedService)
  .service(agentStatusDeprecatedServiceName, AgentStatusDeprecatedService)
  .service(positionDeprecatedServiceName, PositionDeprecatedService)
  // downgrade service
  .factory('agentConfigService', downgradeInjectable(AgentUserConfService) as any)
  .factory('agentStatusService', downgradeInjectable(UserStmService) as any)
  .factory('positionService', downgradeInjectable(PositionService) as any).name;
